import ServiceIntroduction from '@/components/main/landing/supportOverview/ServiceIntroduction';
import SupportInformation from '@/components/main/landing/supportOverview/SupportInformation';

export default function PostListText({ data }) {
  return (
<div className="col-span-12 grid gap-y-6 md:grid-cols-2 md:gap-x-12">
      <ServiceIntroduction data={data} />
      <SupportInformation items={data.items} />
    </div>
  );
}
